import axiosPrivate from "./axiosPrivate";

const getPlanilla = (periodo_planilla) => {
    return axiosPrivate.get(`planilla-negocios`, { params: { periodo_planilla } })
      .then(response => response.data);
};

const guardarPlanilla = (data) => {
    return axiosPrivate.post(`planilla-negocios`, data)
      .then(response => response.data);
};

const validarPlanilla = (periodo_planilla, perfil_id) => {
    return axiosPrivate.post(`planilla-negocios/validar`, { periodo_planilla, perfil_id })
      .then(response => response.data);
};

const PlanillaNegociosService = {
    getPlanilla,
    guardarPlanilla,
    validarPlanilla
};

export default PlanillaNegociosService;
